<template>
  <div class="padding-five-all">
    <b-container fluid>
      <!-- ================= CABECERA ================= -->
      <b-card class="mb-3">
        <b-row>
          <b-col md="3">
            <strong>Liquidación:</strong>
            {{ cabecera.idLiquidacion }}
          </b-col>

          <b-col md="3">
            <strong>Proveedor:</strong>
            {{ cabecera.idProv }}
          </b-col>

          <b-col md="3">
            <strong>Estado:</strong>
            <b-badge variant="success">
              {{ cabecera.estado }}
            </b-badge>
          </b-col>

          <b-col md="3">
            <strong>Periodo:</strong>
            {{ formatDate(cabecera.fechaInicio) }}
            -
            {{ formatDate(cabecera.fechaFin) }}
          </b-col>
        </b-row>
      </b-card>

      <!-- ================= ORDENES ================= -->
      <b-card>
        <b-table
          bordered
          responsive
          show-empty
          :busy="isBusy"
          :items="ordenes"
          :fields="fields"
          details-row
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner />
              <strong>Cargando...</strong>
            </div>
          </template>

          <!-- TOTALES -->
          <template #cell(totalConIgv)="row">
            {{ formatMoney(row.item.totalConIgv) }}
          </template>
          <template #cell(penalidad)="row">
            <span
              v-if="row.item.penalidades && row.item.penalidades.length"
              class="text-danger font-weight-bold"
              v-b-tooltip.hover
              :title="tooltipPenalidades(row.item)"
            >
              - S/ {{ totalPenalidad(row.item).toFixed(2) }} ({{
                porcentajePenalidad(row.item)
              }}%)
            </span>

            <span v-else class="text-muted">—</span>
          </template>
          <template #row-details="row">
            <b-table
              v-if="row.item.detalles && row.item.detalles.length"
              small
              bordered
              responsive
              :items="row.item.detalles"
              :fields="detalleFields"
            />
          </template>
          <!-- FOOTER -->
          <template #custom-foot="{ columns }">
            <b-tr class="bg-light text-muted small">
              <b-td>SUB TOTALES</b-td>
              <b-td :colspan="7" />
              <b-td class="text-right font-weight-bold">
                {{ subTotalCantidad }}
              </b-td>
              <b-td />
              <!-- costo unitario NO se totaliza -->
              <b-td />
              <!-- costo unitario NO se totaliza -->
              <b-td class="text-right">{{ subTotalSinIgv }}</b-td>
              <b-td class="text-right">{{ subTotalConIgv }}</b-td>
              <b-td :colspan="columns - 14" />
            </b-tr>

            <b-tr class="bg-warning">
              <b-td :colspan="columns" class="text-center">
                <span class="h5 font-weight-bold mr-3">
                  TOTAL A FACTURAR
                </span>
                <span class="h4 font-weight-bold">
                  {{ totalAFacturar }}
                </span>
              </b-td>
            </b-tr>
          </template>
        </b-table>
      </b-card>

      <!-- ================= ACCIONES ================= -->
      <b-row class="mt-3">
        <b-col class="text-right">
          <b-button variant="secondary" @click="$router.back()">
            Volver
          </b-button>

          <b-button variant="success" class="ml-2" @click="emitirOc">
            Emitir OC
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "LiquidacionAdministrativoDetalle",

  data() {
    return {
      serviceCache: {},
      isBusy: false,
      cabecera: {},
      ordenes: [],

      fields: [
        { key: "tienda", label: "Tienda", thStyle: { minWidth: "120px" } },
        {
          key: "detSequenceId",
          label: "Nro. OS",
          thStyle: { minWidth: "130px" },
        },
        {
          key: "estado",
          label: "Estado",
          class: "text-center",
          thStyle: { minWidth: "120px" },
        },
        { key: "cliente", label: "Cliente", thStyle: { minWidth: "220px" } },
        {
          key: "skuServicio",
          label: "SKU Servicio",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "descripcionServicio",
          label: "Servicio",
          thStyle: { minWidth: "220px" },
        },
        {
          key: "skuProducto",
          label: "SKU Producto",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "descripcionProducto",
          label: "Producto",
          thStyle: { minWidth: "260px" },
        },
        {
          key: "cantidad",
          label: "Cant.",
          class: "text-right",
          thStyle: { minWidth: "80px" },
        },
        {
          key: "costoSinIgv",
          label: "Costo S/IGV",
          class: "text-right",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "costoConIgv",
          label: "Costo C/IGV",
          class: "text-right",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "totalSinIgv",
          label: "Total S/IGV",
          class: "text-right",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "totalConIgv",
          label: "Total C/IGV",
          class: "text-right",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "penalidad",
          label: "PENALIDAD",
          class: "text-right text-danger",
        },
        {
          key: "servicioEcommerce",
          label: "E-Com",
          class: "text-center",
          thStyle: { minWidth: "90px" },
        },
        {
          key: "obsProveedor",
          label: "Obs. Proveedor",
          thStyle: { minWidth: "220px" },
        },
        {
          key: "obsBackoffice",
          label: "Obs. Gestor",
          thStyle: { minWidth: "220px" },
        },
      ],

      detalleFields: [
        { key: "orden", label: "#" },
        { key: "skuServicio", label: "SKU Servicio" },
        { key: "descripcionServicio", label: "Servicio" },
        { key: "skuProducto", label: "SKU Producto" },
        { key: "descripcionProducto", label: "Producto" },
        { key: "cantidad", label: "Cant.", class: "text-right" },
        { key: "costoSinIgv", label: "Costo S/IGV", class: "text-right" },
        { key: "costoConIgv", label: "Costo C/IGV", class: "text-right" },
        { key: "totalSinIgv", label: "Total S/IGV", class: "text-right" },
        { key: "totalConIgv", label: "Total C/IGV", class: "text-right" },
      ],
    };
  },

  mounted() {
    this.cargarDetalle();
  },
  computed: {
    subTotalCantidad() {
      return this.ordenes.reduce((s, i) => s + Number(i.cantidad || 0), 0);
    },
    subTotalCostoSinIgv() {
      return this.ordenes
        .reduce((s, i) => s + Number(i.costoSinIgv || 0), 0)
        .toFixed(2);
    },
    subTotalCostoConIgv() {
      return this.ordenes
        .reduce((s, i) => s + Number(i.costoConIgv || 0), 0)
        .toFixed(2);
    },
    subTotalSinIgv() {
      return this.ordenes
        .reduce((s, i) => s + i.costoSinIgv * i.cantidad, 0)
        .toFixed(2);
    },
    subTotalConIgv() {
      return this.ordenes
        .reduce((s, i) => s + i.costoConIgv * i.cantidad, 0)
        .toFixed(2);
    },
    totalAFacturar() {
      let totalServicios = 0;
      let totalPenalidades = 0;

      for (const os of this.ordenes) {
        // 🧱 OS PADRE
        totalServicios += Number(os.totalSinIgv || 0);
        totalPenalidades += this.totalPenalidad(os);

        // 🧒 OS HIJAS
        if (os.detalles && os.detalles.length) {
          for (const d of os.detalles) {
            totalServicios += Number(d.totalSinIgv || 0);
          }
        }
      }

      return (totalServicios - totalPenalidades).toFixed(2);
    },
  },
  methods: {
    porcentajePenalidad(os) {
      if (!os.penalidades || !os.penalidades.length) return 0;
      return Math.round(os.penalidades[0].porcentaje * 100);
    },
    tooltipPenalidades(os) {
      return os.penalidades
        .map((p) => `• ${p.descripcion}: S/ ${p.monto.toFixed(2)}`)
        .join("\n");
    },
    totalPenalidad(os) {
      if (!os.penalidades || !os.penalidades.length) return 0;

      return os.penalidades.reduce((sum, p) => sum + Number(p.monto || 0), 0);
    },
    async obtenerCostosServicio(skuServicio, tiendaCodigo) {
      const key = `${skuServicio}-${tiendaCodigo}`;

      if (this.serviceCache[key]) {
        return this.serviceCache[key];
      }

      const { data } = await axios.get(
        `${process.env.VUE_APP_REPORT_VTEX_BASE}/hp/service-system/v1/liquidaciones/servicio-adicional`,
        {
          params: {
            skuServicio,
            tiendaCodigo,
          },
        }
      );

      this.serviceCache[key] = data;
      return data;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatMoney(value) {
      return `S/ ${Number(value).toFixed(2)}`;
    },

    async cargarDetalle() {
      this.isBusy = true;

      try {
        const { idLiquidacion, idTienda } = this.$route.params;

        const { data } = await axios.get(
          `${process.env.VUE_APP_REPORT_VTEX_BASE}` +
            `/hp/service-system/v1/liquidaciones/administrativo/${idLiquidacion}/tienda/${idTienda}`
        );

        this.cabecera = data;

        // Inicializar órdenes
        this.ordenes = (data.ordenes || []).map((o) => ({
          ...o,
          _showDetails: !!(o.detalles && o.detalles.length),
        }));

        // 🔑 COMPLETAR COSTOS DE SERVICIOS ADICIONALES
        for (const os of this.ordenes) {
          if (!os.detalles || !os.detalles.length) continue;

          for (const d of os.detalles) {
            const costo = await this.obtenerCostosServicio(
              d.skuServicio,
              idTienda
            );

            d.costoSinIgv = costo.costoSinIgv;
            d.costoConIgv = costo.costoConIgv;
            d.totalSinIgv = costo.costoSinIgv * d.cantidad;
            d.totalConIgv = costo.costoConIgv * d.cantidad;
          }
        }
      } catch (error) {
        console.error(error);
        this.$bvToast.toast("Error al obtener el detalle de la liquidación", {
          variant: "danger",
          solid: true,
        });
      } finally {
        this.isBusy = false;
      }
    },

    emitirOc() {
      // TODO: endpoint emitir OC
      this.$bvToast.toast("Emisión de OC pendiente de implementar", {
        variant: "info",
        solid: true,
      });
    },
  },
};
</script>
<style scoped>
.text-right {
  text-align: right;
}
</style>
